export interface IStripePriceRecurring {
  interval: 'day' | 'week' | 'month' | 'year';
  intervalCount: number;
  meter: string | null;
  trialPeriodDays: number | null;
  usageType: 'licensed';
}

export class StripePriceRecurring implements IStripePriceRecurring {
  interval: 'day' | 'week' | 'month' | 'year';
  intervalCount: number;
  meter: string | null;
  trialPeriodDays: number | null;
  usageType: 'licensed';

  constructor(data: any) {
    this.interval = data.interval;
    this.intervalCount = data.interval_count;
    this.meter = data.meter;
    this.trialPeriodDays = data.trial_period_days;
    this.usageType = data.usage_type;
  }
}
